import { render, staticRenderFns } from "./_customer.vue?vue&type=template&id=6a8a917d&scoped=true"
import script from "./_customer.vue?vue&type=script&lang=js"
export * from "./_customer.vue?vue&type=script&lang=js"
import style0 from "./_customer.vue?vue&type=style&index=0&id=6a8a917d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8a917d",
  null
  
)

export default component.exports